/* eslint-disable react/prop-types */
import classNames from 'classnames';
import Flex from 'components/common/Flex';
import React from 'react';
import { Button, Form } from 'react-bootstrap';

export const TableFooter = ({
  table,
  totalRows,
  onPageChange,
  onPageSizeChange,
  canNextPage = true,
  canPreviousPage = true,
  loading,
  rowsPerPageOptions = [25],
  hideCount = false,
  next_cursor
}) => {
  const pageIndex = table.getState().pagination.pageIndex;
  const pageCount = table.getPageCount();
  const totalPages = pageCount || 1;

  // Function to get 3 visible page numbers
  const getVisiblePages = () => {
    const currentPage = pageIndex + 1;
    const pages = [];

    if (totalPages <= 3) {
      // If total pages are 3 or less, show all pages
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else if (currentPage === 1) {
      // At first page
      pages.push(1, 2, totalPages);
    } else if (currentPage === totalPages) {
      // At last page
      pages.push(1, totalPages - 1, totalPages);
    } else {
      // In the middle - show current page and neighbors
      pages.push(currentPage - 1, currentPage, currentPage + 1);
    }

    return pages;
  };

  const handlePageChange = page => {
    if (page >= 0 && page < totalPages) {
      onPageChange(page);
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center mt-0 card-footer">
      <div className="d-flex align-items-center gap-2">
        <span className="fs--1">
          Showing{' '}
          {totalRows != 0
            ? pageIndex * table.getState().pagination.pageSize + 1
            : 0}{' '}
          to {next_cursor || totalRows} of {totalRows}
        </span>
        {!hideCount && (
          <>
            <p className="mb-0 mx-2 fs--1">Rows per page:</p>
            <Form.Select
              size="sm"
              className="w-auto"
              onChange={e => onPageSizeChange(e.target.value)}
              defaultValue={10}
            >
              {rowsPerPageOptions.map(value => (
                <option value={value} key={value}>
                  {value}
                </option>
              ))}
            </Form.Select>
          </>
        )}
      </div>

      {/* Pagination Buttons */}
      <div className="btn-group">
        <Flex>
          {/* Previous Arrow Button */}
          <Button
            size="sm"
            variant="light"
            onClick={() => handlePageChange(pageIndex - 1)}
            className={classNames({ disabled: loading || !canPreviousPage })}
          >
            &lt;
          </Button>

          {/* Always show exactly 3 numbers */}
          {getVisiblePages().map((page, index) => (
            <Button
              key={index}
              size="sm"
              variant={page === pageIndex + 1 ? 'primary' : 'light'}
              onClick={() => handlePageChange(page - 1)}
              className="px-3"
            >
              {page}
            </Button>
          ))}

          {/* Next Arrow Button */}
          <Button
            size="sm"
            variant="light"
            onClick={() => handlePageChange(pageIndex + 1)}
            className={classNames({ disabled: loading || !canNextPage })}
          >
            &gt;
          </Button>
        </Flex>
      </div>
    </div>
  );
};
